<template>
  <ContentWrap>
    <el-form :inline="true" :model="q">
      <el-form-item label="关键词"><el-input v-model="q.keyword" clearable /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="q.status" clearable class="!w-140px">
          <el-option label="待审" :value="0" />
          <el-option label="已上架" :value="1" />
          <el-option label="已下架" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column prop="title" label="标题" min-width="180" />
      <el-table-column label="类型" width="80">
        <template #default="s">{{ oppTypeLabel(s.row.oppType) }}</template>
      </el-table-column>
      <el-table-column label="看线索" width="100">
        <template #default="s">{{ leadLabel(s.row.viewPoints) }}</template>
      </el-table-column>
      <el-table-column prop="industry" label="行业" width="120" />
      <el-table-column prop="userId" label="发布者" width="100" />
      <el-table-column prop="contactName" label="联系人(掩码)" width="110" />
      <el-table-column prop="contactPhone" label="电话(掩码)" width="130" />
      <el-table-column prop="viewCount" label="浏览" width="70" />
      <el-table-column prop="leadViewCount" label="解锁" width="70" />
      <el-table-column label="上架截止" width="160">
        <template #default="s">{{ formatExpire(s.row.expireTime) }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90">
        <template #default="s">{{ statusLabel(s.row.status) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="240" fixed="right">
        <template #default="s">
          <el-button link type="primary" @click="openDetail(s.row.id)">详情</el-button>
          <el-button
            v-if="s.row.status === 0"
            v-hasPermi="['bosscircle:biz-opp:audit']"
            link
            type="success"
            @click="status(s.row.id, 1, '通过')"
          >通过</el-button>
          <el-button
            v-if="s.row.status === 0"
            v-hasPermi="['bosscircle:biz-opp:audit']"
            link
            type="danger"
            @click="status(s.row.id, 2, '驳回')"
          >驳回</el-button>
          <el-button
            v-if="s.row.status === 2"
            v-hasPermi="['bosscircle:biz-opp:audit']"
            link
            type="success"
            @click="status(s.row.id, 1, '上架')"
          >上架</el-button>
          <el-button
            v-if="s.row.status === 1"
            v-hasPermi="['bosscircle:biz-opp:audit']"
            link
            type="warning"
            @click="status(s.row.id, 2, '下架')"
          >下架</el-button>
          <el-button
            v-hasPermi="['bosscircle:biz-opp:delete']"
            link
            type="danger"
            @click="del(s.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-model:page="q.pageNo" v-model:limit="q.pageSize" :total="total" @pagination="load" />
  </ContentWrap>

  <el-dialog v-model="detailVisible" title="供需详情" width="780px">
    <el-descriptions v-loading="detailLoading" :column="2" border>
      <el-descriptions-item label="编号">{{ detail.id ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="类型">{{ oppTypeLabel(detail.oppType) }}</el-descriptions-item>
      <el-descriptions-item label="分类">{{ detail.categoryName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="行业">{{ detail.industry || '-' }}</el-descriptions-item>
      <el-descriptions-item label="位置">{{ detail.locationName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="看线索">{{ leadLabel(detail.viewPoints) }}</el-descriptions-item>
      <el-descriptions-item label="发布者ID">{{ detail.userId ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ statusLabel(detail.status) }}</el-descriptions-item>
      <el-descriptions-item label="联系人(掩码)">{{
        detail.contactName || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="电话(掩码)">{{
        detail.contactPhone || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="浏览">{{ detail.viewCount ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="线索解锁">{{
        detail.leadViewCount ?? '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="点赞">{{ detail.likeCount ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="感谢受益">{{ detail.thanksCount ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="评论">{{ detail.commentCount ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="上架截止">{{
        formatExpire(detail.expireTime)
      }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{
        formatTime(detail.createTime)
      }}</el-descriptions-item>
      <el-descriptions-item label="更新时间">{{
        formatTime(detail.updateTime)
      }}</el-descriptions-item>
      <el-descriptions-item label="标题" :span="2">{{ detail.title || '-' }}</el-descriptions-item>
      <el-descriptions-item label="内容" :span="2">
        <div
          v-text="detail.content || '-'"
          class="max-h-200px overflow-auto whitespace-pre-wrap break-all"
        ></div>
      </el-descriptions-item>
      <el-descriptions-item label="图片" :span="2">
        <div v-if="detail.images?.length" class="flex flex-wrap gap-8px">
          <el-image
            v-for="(url, index) in detail.images"
            :key="url"
            :src="url"
            :preview-src-list="detail.images"
            :initial-index="index"
            preview-teleported
            fit="cover"
            class="h-100px w-100px border border-solid border-[var(--el-border-color)]"
          />
        </div>
        <div v-else class="text-12px text-#909399">未上传</div>
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-button @click="detailVisible = false">关 闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { formatDate } from '@/utils/formatTime'
import * as Api from '@/api/business/bizOpp'

defineOptions({ name: 'BossCircleBizOpp' })

const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const q = reactive({
  pageNo: 1,
  pageSize: 10,
  keyword: '',
  status: undefined as number | undefined
})

const load = async () => {
  loading.value = true
  try {
    const d = await Api.getBizOppPage(q)
    list.value = d.list || []
    total.value = d.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  q.pageNo = 1
  load()
}
const formatExpire = (value?: string | number) => {
  if (value == null || value === '') return '长期'
  return formatDate(value) || String(value)
}
const formatTime = (value?: string | number) => (value ? formatDate(value) || '-' : '-')
const oppTypeLabel = (value?: number) => (value === 2 ? '需求' : '供给')
const leadLabel = (value?: number) => (value === 0 ? '免费' : `${value ?? '-'}积分`)
const statusLabel = (value?: number) => ['待审', '已上架', '已下架'][value ?? -1] ?? value ?? '-'

const detailVisible = ref(false)
const detailLoading = ref(false)
const detail = ref<any>({})
const openDetail = async (id: number | string) => {
  detail.value = {}
  detailVisible.value = true
  detailLoading.value = true
  try {
    detail.value = (await Api.getBizOpp(id)) || {}
  } finally {
    detailLoading.value = false
  }
}

const status = async (id: number, s: number, action = '操作') => {
  await message.confirm(`确认${action}该供需？`)
  await Api.updateBizOppStatus(id, s)
  message.success(`${action}成功`)
  load()
}
const del = async (id: number) => {
  await message.delConfirm()
  await Api.deleteBizOpp(id)
  message.success('删除成功')
  load()
}

onMounted(load)
</script>
